import { Box, IconButton, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import { visibilityOptions } from "../utils/utils";

const getIconForValue = (value) =>
  visibilityOptions.find((opt) => opt.value === value)?.icon || null;

const getLabelForValue = (value) => {
  const label =
    visibilityOptions.find((opt) => opt.value === value)?.label || "";
  return label === "Only me" ? "Only you" : label;
};

export default function VisibilityIcon({
  value,
  noun,
  color = "inherit",
  disablePopover = false,
  anchor = "right",
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const icon = getIconForValue(value);
  const clonedIcon =
    icon && React.cloneElement(icon, { fontSize: "small", sx: { color } });

  if (disablePopover) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>{clonedIcon}</Box>
    );
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        sx={{ p: 0 }}
      >
        {clonedIcon}
      </IconButton>
      <Popover
        id="visibility-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "center",
          horizontal: anchor === "left" ? 25 : -5,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: anchor === "left" ? "left" : "right",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">
            {getLabelForValue(value)} can see this {noun}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}
